var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState, useContext, useEffect } from "react";
import firebase from "firebase/compat/app";
import { BreadcrumbContext } from "../../../../components/Breadcrumb";
import Loader from '../../../../components/Loader';
import { Form, Field, Input, Select, MultiSelect } from "../../../../components/Form";
import { AuthContext } from "../../../../components/FirebaseAuth";
import { CloudFunctions, FirebaseAuth } from "../../../../components/FirebaseAuth/firebase";
import Alert from "../../../../components/Alert";
import { superAdmins } from "../../superAdmins";
import CustomDomain from "../../../../components/APISettings/CustomDomain";
import ApiKey from "../../../../components/APISettings/ApiKey";
import OAuthSecrets from "../../../../components/APISettings/OAuthSecrets";
import EnableLegacyLTI from "../../../../components/APISettings/EnableLegacyLTI";
import ConsumerPublicKey from "../../../../components/APISettings/ConsumerPublicKey";
import SubdomainField from "../../../../components/APISettings/SubdomainField";
import { placementOptions } from "./DynamicRegistrationSettings";
import AccountSteps from "../../../../components/AccountSteps";
var APISettings = function () {
    var _a, _b, _c;
    var title = "API Settings";
    var _d = useState({
        hasError: false,
        error: null,
        value: ".ltiaas.com",
    }), subdomainName = _d[0], setSubdomainName = _d[1];
    var _e = useState({
        hasError: false,
        error: null,
        value: "us-central1",
    }), zoneName = _e[0], setZoneName = _e[1];
    var _f = useState({
        hasError: false,
        error: null,
        value: ["default"],
    }), placementsCore = _f[0], setPlacementsCore = _f[1];
    var _g = useState({
        hasError: false,
        error: null,
        value: ["default"],
    }), placementsDeepLinking = _g[0], setPlacementsDeepLinking = _g[1];
    var _h = useState([]), zoneOptions = _h[0], setZoneOptions = _h[1];
    var _j = useState({
        deepLinking: false,
        dynamicRegistration: false,
        customSubdomain: false,
        consumerService: false,
        oauth: false,
        assetProcessor: false,
    }), services = _j[0], setServices = _j[1];
    var changeZoneName = function (e) {
        if (!services.customSubdomain) {
            var foundZone = zoneOptions.find(function (z) { return z.value === e.value; });
            var domain = foundZone ? foundZone.prefix : ".ltiaas.com";
            if (!settingsCommitted) {
                setSubdomainName({ value: domain, hasError: false, error: null });
            }
        }
        setZoneName(e);
    };
    React.useEffect(function () {
        if (zoneOptions.length > 0 && !settingsCommitted) {
            changeZoneName({
                hasError: false,
                error: null,
                value: zoneOptions[0].value
            });
        }
    }, [zoneOptions]);
    var _k = useState({
        hasError: false,
        error: null,
        value: "",
    }), toolName = _k[0], setToolName = _k[1];
    var _l = useState({
        hasError: false,
        error: null,
        value: "",
    }), toolDescription = _l[0], setToolDescription = _l[1];
    var _m = useState({
        hasError: false,
        error: null,
        value: "",
    }), launchURL = _m[0], setLaunchURL = _m[1];
    var _o = useState({
        hasError: false,
        error: null,
        value: "",
    }), deepLinkingURL = _o[0], setDeepLinkingURL = _o[1];
    var _p = useState({
        hasError: false,
        error: null,
        value: "",
    }), dynamicRegistrationURL = _p[0], setDynamicRegistrationURL = _p[1];
    var _q = useState({
        hasError: false,
        error: null,
        value: "",
    }), oauthRedirectURL = _q[0], setOauthRedirectURL = _q[1];
    var _r = useState({
        hasError: false,
        error: null,
        value: "",
    }), noticeURL = _r[0], setNoticeURL = _r[1];
    var _s = useState({
        hasError: false,
        error: null,
        value: "",
    }), logoURL = _s[0], setLogoURL = _s[1];
    var _t = useState({
        hasError: false,
        error: null,
        value: "false",
    }), autoActivate = _t[0], setAutoActivate = _t[1];
    var _u = useState({
        hasError: false,
        error: null,
        value: "false",
    }), loadIntermediateTarget = _u[0], setLoadIntermediateTarget = _u[1];
    var _v = useState({
        hasError: false,
        error: null,
        value: "",
    }), serviceURL = _v[0], setServiceURL = _v[1];
    var _w = useState({}), account = _w[0], setAccount = _w[1];
    var _x = useState("provider"), planType = _x[0], setPlanType = _x[1];
    var _y = useState("kubernetes"), deploymentMethod = _y[0], setDeploymentMethod = _y[1];
    var _z = useState(null), errorMessage = _z[0], setErrorMessage = _z[1];
    var _0 = useState(null), deployErrorMessage = _0[0], setDeployErrorMessage = _0[1];
    var _1 = useState(null), deploySuccessMessage = _1[0], setDeploySuccessMessage = _1[1];
    var _2 = useState(false), inSubmit = _2[0], setInSubmit = _2[1];
    var _3 = useState(false), inDeploy = _3[0], setInDeploy = _3[1];
    var _4 = useState(null), apiKey = _4[0], setApiKey = _4[1];
    var _5 = useState(false), settingsCommitted = _5[0], setSettingsCommitted = _5[1];
    var _6 = useState(false), deployNeeded = _6[0], setDeployNeeded = _6[1];
    var _7 = useState(false), hasBeenDeployed = _7[0], setHasBeenDeployed = _7[1];
    var _8 = useState(false), dedicatedCPUProvisioning = _8[0], setDedicatedCPUProvisioning = _8[1];
    var _9 = useState({
        hasError: false,
        error: null,
        value: "",
    }), apiErrorEmail = _9[0], setApiErrorEmail = _9[1];
    var _10 = useState(false), inTestEmail = _10[0], setInTestEmail = _10[1];
    var _11 = useState(null), emailTestMessage = _11[0], setEmailTestMessage = _11[1];
    var _12 = useContext(AuthContext), userData = _12.userData, authUser = _12.authUser;
    var setBreadcrumb = useContext(BreadcrumbContext).setBreadcrumb;
    var _13 = useState(false), guide = _13[0], setGuide = _13[1];
    // get 'guide' query parameter
    useEffect(function () {
        var urlParams = new URLSearchParams(window.location.search);
        var guideParam = urlParams.get("guide");
        setGuide(guideParam === "true");
    }, []);
    var validateAllFields = function () {
        // Validate subdomain
        var foundZone = zoneOptions.find(function (z) { return z.value === zoneName.value; });
        var domain = foundZone ? foundZone.prefix : ".ltiaas.com";
        if (subdomainName.value === "" || subdomainName.value === domain) {
            setSubdomainName(function (prev) { return (__assign(__assign({}, prev), { hasError: true, error: subdomainName.value === "" ? "This is a required field." : "Please enter a custom subdomain name." })); });
        }
        // Validate tool name
        if (toolName.value === "") {
            setToolName(function (prev) { return (__assign(__assign({}, prev), { hasError: true, error: "This is a required field." })); });
        }
        // Validate tool description (only for provider type)
        if (toolDescription.value === "" && planType === "provider") {
            setToolDescription(function (prev) { return (__assign(__assign({}, prev), { hasError: true, error: "This is a required field." })); });
        }
        // Validate launch URL
        if (launchURL.value === "") {
            setLaunchURL(function (prev) { return (__assign(__assign({}, prev), { hasError: true, error: "This is a required field." })); });
        }
        // Validate service URL (if needed)
        if (serviceURL.value === "" && planType === "consumer" && services.consumerService) {
            setServiceURL(function (prev) { return (__assign(__assign({}, prev), { hasError: true, error: "This is a required field." })); });
        }
        // Validate deep linking URL
        if (deepLinkingURL.value === "" && services.deepLinking) {
            setDeepLinkingURL(function (prev) { return (__assign(__assign({}, prev), { hasError: true, error: "This is a required field." })); });
        }
        // Validate dynamic registration URL
        if (services.dynamicRegistration && loadIntermediateTarget.value === "true" && dynamicRegistrationURL.value === "") {
            setDynamicRegistrationURL(function (prev) { return (__assign(__assign({}, prev), { hasError: true, error: "This is a required field." })); });
        }
        // Validate OAuth redirect URL
        if (services.oauth && oauthRedirectURL.value === "") {
            setOauthRedirectURL(function (prev) { return (__assign(__assign({}, prev), { hasError: true, error: "This is a required field." })); });
        }
        // Validate Asset Processor notice URL
        if (services.assetProcessor && planType === "provider" && noticeURL.value === "") {
            setNoticeURL(function (prev) { return (__assign(__assign({}, prev), { hasError: true, error: "This is a required field." })); });
        }
    };
    function validateForm() {
        var foundZone = zoneOptions.find(function (z) { return z.value === zoneName.value; });
        var domain = foundZone ? foundZone.prefix : ".ltiaas.com";
        return (subdomainName.hasError ||
            subdomainName.value === "" ||
            subdomainName.value === domain ||
            toolName.hasError ||
            toolName.value === "" ||
            toolDescription.hasError ||
            (toolDescription.value === "" && planType === "provider") ||
            launchURL.hasError ||
            serviceURL.hasError ||
            launchURL.value === "" ||
            (deepLinkingURL.value === "" && services.deepLinking) ||
            deepLinkingURL.hasError ||
            logoURL.hasError ||
            autoActivate.hasError ||
            (services.dynamicRegistration && loadIntermediateTarget.value === "true" && dynamicRegistrationURL.value === "") ||
            dynamicRegistrationURL.hasError ||
            (services.oauth && oauthRedirectURL.value === "") ||
            oauthRedirectURL.hasError ||
            (services.assetProcessor && planType === "provider" && noticeURL.value === "") ||
            noticeURL.hasError ||
            inSubmit);
    }
    var updateAPISettings = function () { return __awaiter(void 0, void 0, void 0, function () {
        var settings, subdomains, querySnapshot, collectionRef, collectionRef2, existingSubdomain, existingSubdomainData, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setInSubmit(true);
                    settings = {
                        toolName: toolName.value,
                        toolDescription: toolDescription.value,
                        launchURL: launchURL.value,
                        serviceURL: serviceURL.value,
                        deepLinkingURL: deepLinkingURL.value,
                        dynamicRegistrationURL: dynamicRegistrationURL.value,
                        oauthRedirectURL: oauthRedirectURL.value,
                        noticeURL: noticeURL.value,
                        logoURL: logoURL.value,
                        autoActivate: autoActivate.value,
                        apiErrorEmail: apiErrorEmail.value,
                        loadIntermediateTarget: loadIntermediateTarget.value,
                        placementsCore: placementsCore.value,
                        placementsDeepLinking: placementsDeepLinking.value,
                        lastSave: firebase.firestore.Timestamp.now()
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 8, , 9]);
                    subdomains = FirebaseAuth.firestore()
                        .collection("subdomains")
                        .where("subdomainName", "==", subdomainName.value);
                    return [4 /*yield*/, subdomains.get()];
                case 2:
                    querySnapshot = _a.sent();
                    querySnapshot.forEach(function (doc) {
                        if (doc.id !== userData.currentAccount.id) {
                            setSettingsCommitted(false);
                            throw new Error("Sorry, this subdomain is reserved. Please choose a different one.");
                        }
                    });
                    collectionRef = FirebaseAuth.firestore()
                        .collection("accounts")
                        .doc(userData.currentAccount.id)
                        .collection("api_settings")
                        .doc("private");
                    return [4 /*yield*/, collectionRef.set(settings, { merge: true })];
                case 3:
                    _a.sent();
                    collectionRef2 = FirebaseAuth.firestore()
                        .collection("subdomains")
                        .doc(userData.currentAccount.id);
                    if (!services.customSubdomain) return [3 /*break*/, 6];
                    return [4 /*yield*/, collectionRef2.get()];
                case 4:
                    existingSubdomain = _a.sent();
                    if (!existingSubdomain.exists) return [3 /*break*/, 6];
                    existingSubdomainData = existingSubdomain.data();
                    if (!(existingSubdomainData !== undefined && existingSubdomainData.subdomainName !== subdomainName.value)) return [3 /*break*/, 6];
                    //Delete the old subdomain
                    return [4 /*yield*/, deleteOldDomain()];
                case 5:
                    //Delete the old subdomain
                    _a.sent();
                    _a.label = 6;
                case 6: return [4 /*yield*/, collectionRef2.set({
                        subdomainName: subdomainName.value,
                        zone: zoneName.value
                    })
                    // Toggle to get custom domain to start a new check
                ];
                case 7:
                    _a.sent();
                    // Toggle to get custom domain to start a new check
                    setSettingsCommitted(!settingsCommitted);
                    setSettingsCommitted(!validateForm());
                    setDeployNeeded(true);
                    return [3 /*break*/, 9];
                case 8:
                    err_1 = _a.sent();
                    setSubdomainName({
                        hasError: true,
                        error: err_1.message,
                        value: subdomainName.value
                    });
                    setErrorMessage(err_1.message);
                    return [3 /*break*/, 9];
                case 9:
                    setInSubmit(false);
                    setDeployErrorMessage(null);
                    if (!validateForm()) {
                        window.scrollTo({
                            top: 0,
                            left: 0,
                            behavior: 'smooth'
                        });
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var deleteOldDomain = function () { return __awaiter(void 0, void 0, void 0, function () {
        var onCall;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    onCall = CloudFunctions.httpsCallable('oncall');
                    return [4 /*yield*/, onCall({
                            name: "deleteOldDomain",
                            data: {
                                accountId: userData.currentAccount.id,
                            }
                        })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var sendTestEmail = function () { return __awaiter(void 0, void 0, void 0, function () {
        var testEmail;
        return __generator(this, function (_a) {
            setInTestEmail(true);
            setEmailTestMessage(null);
            testEmail = CloudFunctions.httpsCallable('oncall');
            testEmail({
                name: "sendTestApiErrorEmail",
                data: {
                    accountId: userData.currentAccount.id,
                    email: apiErrorEmail.value
                }
            }).then(function (res) {
                setEmailTestMessage("Test email sent.");
                setInTestEmail(false);
            }).catch(function (err) {
                setEmailTestMessage(err.message);
                setInTestEmail(false);
            });
            return [2 /*return*/];
        });
    }); };
    var triggerDeploy = function () { return __awaiter(void 0, void 0, void 0, function () {
        var notGood, deployAccount;
        return __generator(this, function (_a) {
            setInDeploy(true);
            setDeployErrorMessage(null);
            // Validate all fields first to show errors
            validateAllFields();
            if (deepLinkingURL.value === "" && services.deepLinking) {
                setDeepLinkingURL(__assign(__assign({}, deepLinkingURL), { hasError: true, error: "This is a required field." }));
                setDeployErrorMessage("Please fix the errors below.");
                setInDeploy(false);
                return [2 /*return*/];
            }
            notGood = validateForm();
            if (notGood) {
                setDeployErrorMessage("Please fix the errors below.");
                setInDeploy(false);
                return [2 /*return*/];
            }
            deployAccount = CloudFunctions.httpsCallable('oncall');
            deployAccount({
                name: "deployAccount",
                data: {
                    accountId: userData.currentAccount.id
                }
            }).then(function (res) {
                var settings = {
                    lastDeploy: firebase.firestore.Timestamp.now()
                };
                var collectionRef = FirebaseAuth.firestore()
                    .collection("accounts")
                    .doc(userData.currentAccount.id)
                    .collection("api_settings")
                    .doc("private");
                collectionRef.set(settings, { merge: true });
                setInDeploy(false);
                setDeployNeeded(false);
                var DNSmessage = (services.customSubdomain && !subdomainName.value.includes(".ltiaas.com")) ? "" : "If this is your first time deploying, please be patient as it may take up to an hour for a DNS change to propagate.";
                setDeploySuccessMessage("Deploy Triggered Successfully. Your changes will be live at: https://".concat(subdomainName.value, " immediately. ").concat(DNSmessage));
            }).catch(function (err) {
                setDeployErrorMessage(err.message);
                setInDeploy(false);
            });
            return [2 /*return*/];
        });
    }); };
    var fetchSettings = function (accountId) { return __awaiter(void 0, void 0, void 0, function () {
        var active_plans, api_settings, account, collectionRef, account_doc, planPromises, plans, collectionRef1, doc, collectionRef3, doc3, has_subdomain, subdomain, collectionRef2, doc2, account_settings, extra_zones_1, zones, zone_options_1, querySnapshot;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    active_plans = {
                        deepLinking: false,
                        dynamicRegistration: false,
                        customSubdomain: false,
                        consumerService: false,
                        oauth: false,
                        assetProcessor: false
                    };
                    api_settings = undefined;
                    account = undefined;
                    collectionRef = FirebaseAuth.firestore()
                        .collection("accounts")
                        .doc(accountId);
                    return [4 /*yield*/, collectionRef.get()];
                case 1:
                    account_doc = _c.sent();
                    account = account_doc.data();
                    if (!(account_doc.exists && account !== undefined)) return [3 /*break*/, 3];
                    setAccount(account);
                    if (account.hasOwnProperty("type")) {
                        setPlanType(account.type);
                    }
                    if (account.hasOwnProperty("firebase") && account.firebase === true) {
                        setDeploymentMethod("firebase");
                    }
                    if (!account.hasOwnProperty("plans")) return [3 /*break*/, 3];
                    planPromises = account.plans.map(function (plan) {
                        return plan.get();
                    });
                    return [4 /*yield*/, Promise.all(planPromises)];
                case 2:
                    plans = _c.sent();
                    plans.forEach(function (plan) {
                        var _a;
                        if (plan.data().name.includes("Deep Linking")) {
                            active_plans.deepLinking = true;
                        }
                        if (plan.data().name.includes("Dynamic Registration")) {
                            active_plans.dynamicRegistration = true;
                            active_plans.consumerService = true;
                        }
                        if (plan.data().name.includes("Grades")) {
                            active_plans.consumerService = true;
                        }
                        if (plan.data().name.includes("Roles")) {
                            active_plans.consumerService = true;
                        }
                        if (plan.data().name.includes("OAuth")) {
                            active_plans.oauth = true;
                        }
                        if (plan.data().name.includes("Asset Processor")) {
                            active_plans.assetProcessor = true;
                        }
                        if (plan.data().name.includes("Custom Domain Name") || ((_a = userData.currentAccount.features) === null || _a === void 0 ? void 0 : _a.custom_domain)) {
                            active_plans.customSubdomain = true;
                            setSubdomainName({
                                hasError: false,
                                error: null,
                                value: "",
                            });
                        }
                    });
                    setServices(active_plans);
                    _c.label = 3;
                case 3:
                    collectionRef1 = FirebaseAuth.firestore()
                        .collection("accounts")
                        .doc(accountId)
                        .collection("api_settings")
                        .doc("private");
                    return [4 /*yield*/, collectionRef1.get()];
                case 4:
                    doc = _c.sent();
                    api_settings = doc.data();
                    if (doc.exists && api_settings !== undefined) {
                        if (api_settings.hasOwnProperty("toolName")) {
                            setToolName({ value: api_settings.toolName, error: null, hasError: false });
                        }
                        if (api_settings.hasOwnProperty("toolDescription")) {
                            setToolDescription({ value: api_settings.toolDescription, error: null, hasError: false });
                        }
                        if (api_settings.hasOwnProperty("launchURL")) {
                            setLaunchURL({ value: api_settings.launchURL, error: null, hasError: false });
                        }
                        if (api_settings.hasOwnProperty("deepLinkingURL")) {
                            setDeepLinkingURL({ value: api_settings.deepLinkingURL, error: null, hasError: false });
                        }
                        if (api_settings.hasOwnProperty("dynamicRegistrationURL")) {
                            setDynamicRegistrationURL({ value: api_settings.dynamicRegistrationURL, error: null, hasError: false });
                        }
                        if (api_settings.hasOwnProperty("oauthRedirectURL")) {
                            setOauthRedirectURL({ value: api_settings.oauthRedirectURL, error: null, hasError: false });
                        }
                        if (api_settings.hasOwnProperty("noticeURL")) {
                            setNoticeURL({ value: api_settings.noticeURL, error: null, hasError: false });
                        }
                        if (api_settings.hasOwnProperty("logoURL")) {
                            setLogoURL({ value: api_settings.logoURL, error: null, hasError: false });
                        }
                        if (api_settings.hasOwnProperty("autoActivate")) {
                            setAutoActivate({ value: api_settings.autoActivate, error: null, hasError: false });
                        }
                        if (api_settings.hasOwnProperty("loadIntermediateTarget")) {
                            setLoadIntermediateTarget({ value: api_settings.loadIntermediateTarget, error: null, hasError: false });
                        }
                        if (api_settings.hasOwnProperty("placementsCore")) {
                            setPlacementsCore({ value: api_settings.placementsCore, error: null, hasError: false });
                        }
                        if (api_settings.hasOwnProperty("placementsDeepLinking")) {
                            setPlacementsDeepLinking({ value: api_settings.placementsDeepLinking, error: null, hasError: false });
                        }
                        if (api_settings.hasOwnProperty("serviceURL")) {
                            setServiceURL({ value: api_settings.serviceURL, error: null, hasError: false });
                        }
                        if (api_settings.hasOwnProperty("apiErrorEmail")) {
                            setApiErrorEmail({ value: api_settings.apiErrorEmail, error: null, hasError: false });
                        }
                        if (api_settings.hasOwnProperty("lastDeploy")) {
                            setHasBeenDeployed(true);
                        }
                        if (api_settings.hasOwnProperty("lastSave")) {
                            if (api_settings.hasOwnProperty("lastDeploy")) {
                                if (((_a = authUser.user) === null || _a === void 0 ? void 0 : _a.uid) && superAdmins.includes(authUser.user.uid)) {
                                    setDeployNeeded(true);
                                }
                                else if (api_settings.lastSave.toDate() > api_settings.lastDeploy.toDate()) {
                                    setDeployNeeded(true);
                                }
                                else {
                                    setDeployNeeded(false);
                                }
                            }
                            else {
                                setDeployNeeded(true);
                            }
                        }
                    }
                    collectionRef3 = FirebaseAuth.firestore()
                        .collection("subdomains")
                        .doc(accountId);
                    return [4 /*yield*/, collectionRef3.get()];
                case 5:
                    doc3 = _c.sent();
                    has_subdomain = false;
                    if (doc3.exists) {
                        subdomain = doc3.data();
                        if (subdomain !== undefined && subdomain.hasOwnProperty("subdomainName")) {
                            setSubdomainName({ value: subdomain.subdomainName, hasError: false, error: null });
                            has_subdomain = true;
                        }
                        if (subdomain !== undefined && subdomain.hasOwnProperty("zone")) {
                            setZoneName({ value: subdomain.zone, hasError: false, error: null });
                        }
                    }
                    collectionRef2 = FirebaseAuth.firestore()
                        .collection("accounts")
                        .doc(accountId);
                    return [4 /*yield*/, collectionRef2.get()];
                case 6:
                    doc2 = _c.sent();
                    if (!doc2.exists) return [3 /*break*/, 8];
                    account_settings = doc2.data();
                    if (account_settings !== undefined && account_settings.hasOwnProperty("apiKey")) {
                        setApiKey(account_settings.apiKey);
                    }
                    else {
                        setApiKey("");
                    }
                    extra_zones_1 = [];
                    if (account_settings !== undefined && account_settings.hasOwnProperty("availableZones")) {
                        account_settings.availableZones.forEach(function (z) {
                            extra_zones_1.push(z.value);
                        });
                    }
                    else if ((_b = userData.currentAccount.features) === null || _b === void 0 ? void 0 : _b.dedicated_cpu) {
                        setDedicatedCPUProvisioning(true);
                    }
                    zones = FirebaseAuth.firestore().collection("zones");
                    zone_options_1 = [];
                    return [4 /*yield*/, zones.get()];
                case 7:
                    querySnapshot = _c.sent();
                    // put private zones at the top of the list
                    querySnapshot.forEach(function (doc) {
                        if (extra_zones_1.includes(doc.id)) {
                            zone_options_1.push({
                                value: doc.id,
                                label: doc.data().name,
                                prefix: doc.data().subdomainPrefix,
                                disabled: (!((account === null || account === void 0 ? void 0 : account.hasOwnProperty("firebase")) && account.firebase === true)) && doc.id !== "us-central1"
                            });
                        }
                    });
                    // Add USA at the top of the list
                    querySnapshot.forEach(function (doc) {
                        if (doc.data().public && doc.data().name.includes("US")) {
                            zone_options_1.push({
                                value: doc.id,
                                label: doc.data().name,
                                prefix: doc.data().subdomainPrefix,
                                disabled: (!((account === null || account === void 0 ? void 0 : account.hasOwnProperty("firebase")) && account.firebase === true)) && doc.id !== "us-central1"
                            });
                        }
                    });
                    // Add non-USA options
                    querySnapshot.forEach(function (doc) {
                        if (doc.data().public && !doc.data().name.includes("US")) {
                            zone_options_1.push({
                                value: doc.id,
                                label: doc.data().name,
                                prefix: doc.data().subdomainPrefix,
                                disabled: (!((account === null || account === void 0 ? void 0 : account.hasOwnProperty("firebase")) && account.firebase === true)) && doc.id !== "us-central1"
                            });
                        }
                    });
                    if (has_subdomain) {
                        setSettingsCommitted(validateForm());
                    }
                    setZoneOptions(zone_options_1);
                    return [3 /*break*/, 9];
                case 8:
                    setApiKey("");
                    _c.label = 9;
                case 9:
                    if (has_subdomain) {
                        setSettingsCommitted(validateForm());
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        fetchSettings(userData.currentAccount.id);
        setBreadcrumb([
            {
                to: "/",
                text: "Home",
                active: false,
            },
            {
                to: "/account/" + userData.currentAccount.id + "/",
                text: userData.currentAccount.name + " (".concat(userData.currentAccount.id, ")"),
                active: false,
            },
            {
                to: null,
                text: title,
                active: true,
            },
        ]);
    }, [setBreadcrumb, title]);
    return (_jsx(_Fragment, { children: _jsx("div", { className: "container-fluid", children: _jsxs("div", { className: "animated fadeIn", children: [dedicatedCPUProvisioning &&
                        _jsx("div", { className: "alert alert-warning", role: "alert", children: _jsxs("p", { children: ["Your dedicated CPU and Database are currently being provisioned. This process can take up to 24 hours.", " ", "Please check back here later. If you have any questions or concerns, please reach out to ", _jsx("a", { href: "mailto:support@ltiaas.com", children: "mailto:support@ltiaas.com" }), "."] }) }), apiKey !== null && settingsCommitted && deployNeeded && (_jsxs("div", { className: "card border-danger mb-3", children: [_jsx("div", { className: "card-header text-danger", children: "Deploy Needed" }), _jsxs("div", { className: "card-body text-danger", children: [_jsx("p", { children: "Your API settings have been saved, but they have not been deployed." }), _jsxs("button", { className: "btn mr-2 btn-danger", onClick: triggerDeploy, disabled: inDeploy, children: [inDeploy && _jsx(Loader, {}), 'Deploy Now'] })] })] })), deployErrorMessage !== null && (_jsx(Alert, { type: "danger", message: deployErrorMessage, dismissible: true, onDismiss: function () { return setDeployErrorMessage(null); } })), _jsx(AccountSteps, { accountSettingsComplete: (settingsCommitted || apiKey == null) && !deployNeeded, subscriptionStatus: "active", numRegistrations: null, onAPISettingsPage: true, onRegistrationsPage: false, hidden: !guide }), _jsx(CustomDomain, { enabled: settingsCommitted && services.customSubdomain && deploymentMethod === "firebase" && subdomainName.value.length > 0 && !subdomainName.value.endsWith(".ltiaas.com"), subdomainName: subdomainName.value, settingsCommitted: settingsCommitted, account: account }), _jsx(ApiKey, { settingsCommitted: settingsCommitted, deploymentMethod: deploymentMethod, accountApiKey: apiKey }), _jsx(ConsumerPublicKey, { enabled: settingsCommitted && deploymentMethod === "firebase" && planType === "consumer" }), _jsx(OAuthSecrets, { enabled: settingsCommitted && deploymentMethod === "firebase" && planType !== "consumer" && ((_a = userData.currentAccount.features) === null || _a === void 0 ? void 0 : _a.legacy_lti_support) }), _jsx(EnableLegacyLTI, { enabled: hasBeenDeployed && settingsCommitted && deploymentMethod === "firebase" && planType !== "consumer" && !((_b = userData.currentAccount.features) === null || _b === void 0 ? void 0 : _b.legacy_lti_support), accountId: userData.currentAccount.id }), deploySuccessMessage !== null && (_jsx(Alert, { type: "success", message: deploySuccessMessage, dismissible: true, onDismiss: function () { return setDeploySuccessMessage(null); } })), _jsxs("div", { className: "card", children: [_jsx("div", { className: "card-header", children: title }), _jsx("div", { className: "card-body", children: _jsxs(Form, { handleSubmit: function (e) {
                                        e.preventDefault();
                                        // Validate all fields first to show errors
                                        validateAllFields();
                                        // Only proceed if form is valid
                                        if (!validateForm()) {
                                            setInSubmit(true);
                                            setErrorMessage(null);
                                            updateAPISettings().catch(function (err) {
                                                setErrorMessage(err.message);
                                                setInSubmit(false);
                                            });
                                        }
                                    }, disabled: validateForm(), inSubmit: inSubmit, submitBtnText: "Save Changes", enableDefaultButtons: true, children: [deploymentMethod === "firebase" &&
                                            _jsx(Field, { label: "Data Region", description: "Choose the region in which you want your data hosted in. NOTE: After this is provisioned, it cannot be changed. If you want to change your data region after provisioning, please contact support@ltiaas.com.", children: _jsx(Select, { value: zoneName.value, name: "zone-name", required: true, disabled: settingsCommitted, error: zoneName.error, hasError: zoneName.hasError, options: zoneOptions, changeHandler: changeZoneName }) }), _jsx(SubdomainField, { services: services, settingsCommitted: settingsCommitted, subdomainName: subdomainName, setSubdomainName: setSubdomainName, zoneName: zoneName, zoneOptions: zoneOptions }), _jsx(Field, { label: planType === "consumer" ? "Name" : "Tool Name", description: planType === "consumer" ? "This is the name that is saved into the tool's database." : "This is the title that is displayed in the LMS after the tool is linked.", children: _jsx(Input, { type: "text", value: toolName.value, name: "tool-name", maxLen: 100, required: true, changeHandler: setToolName, error: toolName.error, hasError: toolName.hasError }) }), planType === "provider" &&
                                            _jsx(Field, { label: "Tool Description", description: "This is the short description that is displayed in the LMS after the tool is linked. Just a short sentence is best.", children: _jsx(Input, { type: "text", value: toolDescription.value, name: "tool-description", maxLen: 100, required: true, changeHandler: setToolDescription, error: toolDescription.error, hasError: toolDescription.hasError }) }), _jsx(Field, { label: "Launch URL", description: planType === "consumer" ? "This is the URL (on your server) that is provisioned to receive LTI launch requests from tools (ex. https://example.com/lti-launch). It will receive a POST request with a JWT that needs to be validated with your public key. You will then take that information and send it to the LTIAAS consumer idtoken endpoint." : "This is the URL (on your server) that is provisioned to receive LTI launch commands. (ex. https://example.com/lti-launch). It will receive a GET request with a query parameter that you can use to authenticate the connection by querying our API.", children: _jsx(Input, { type: "text", value: launchURL.value, name: "launch-url", maxLen: 500, required: true, validRegex: "^https?:\\/\\/[a-zA-Z0-9\\.\\-\\_]+.+", customErrorMessage: "Must be a valid URL starting with http(s)://", changeHandler: setLaunchURL, error: launchURL.error, hasError: launchURL.hasError }) }), planType === "consumer" && services.consumerService &&
                                            _jsx(Field, { label: "Service URL", description: "This is the URL (on your server) that LTIAAS redirects to after receiving service requests. (ex. https://example.com/lti-service).", children: _jsx(Input, { type: "text", value: serviceURL.value, name: "service-url", maxLen: 500, required: true, validRegex: "^https?:\\/\\/[a-zA-Z0-9\\.\\-\\_]+.+", customErrorMessage: "Must be a valid URL starting with http(s)://", changeHandler: setServiceURL, error: serviceURL.error, hasError: serviceURL.hasError }) }), services.deepLinking &&
                                            _jsxs(_Fragment, { children: [_jsx("div", { className: "card-header rounded-top bg-light mb-3", children: "Deep Linking Settings" }), _jsx(Field, { label: "Deep Linking URL", description: "For LTI Deep Linking, this is the URL (on your server) that is provisioned to receive LTI deep-linking commands. This will be the page that is displayed to the teacher that allows them to select/configure an activity. (ex. https://example.com/lti-deep-linking). It will receive a GET request with a query parameter that you can use to authenticate the connection by querying our API.", children: _jsx(Input, { type: "text", value: deepLinkingURL.value, name: "deep-linking-url", maxLen: 500, required: true, error: deepLinkingURL.error, hasError: deepLinkingURL.hasError, validRegex: "^https?:\\/\\/[a-zA-Z0-9\\.\\-\\_]+.+", customErrorMessage: "Must be a valid URL starting with http(s)://", changeHandler: setDeepLinkingURL }) })] }), services.dynamicRegistration &&
                                            _jsx("div", { className: "card-header rounded-top bg-light mb-3", children: "Dynamic Registration Settings" }), planType === "provider" &&
                                            _jsx(Field, { label: "Logo URL", logo: logoURL.value, description: services.dynamicRegistration ? "The URL to your tool's logo that will be shown in the LMS. Recommended size: 128x128px. This should be a URL to an image hosted by you." : "The URL to your tool's logo that will be shown in the unlikely event that an error message needs to be displayed to the user.", children: _jsx(Input, { type: "text", value: logoURL.value, name: "logo-url", maxLen: 100, required: true, validRegex: "^https?:\\/\\/[a-zA-Z0-9\\.\\-\\_]+.+", customErrorMessage: "Must be a valid URL starting with http(s)://", changeHandler: setLogoURL, error: logoURL.error, hasError: logoURL.hasError }) }), services.dynamicRegistration && planType === "provider" &&
                                            _jsxs(_Fragment, { children: [_jsx(Field, { label: "Core Launch Placements", description: "Choose the locations in the LMS that you want your tool to be available in when your tool is launched.", children: _jsx(MultiSelect, { value: placementsCore.value.map(function (v) { return placementOptions.find(function (p) { return p.value === v; }); }), name: "placements-core", required: true, creatable: true, disabled: inSubmit, error: placementsCore.error, hasError: placementsCore.hasError, options: placementOptions, changeHandler: setPlacementsCore }) }), services.deepLinking &&
                                                        _jsx(Field, { label: "Deep-Linking Launch Placements", description: "Choose the locations in the LMS that you want your tool to be available in when your tool is launched via deep-linking.", children: _jsx(MultiSelect, { value: placementsDeepLinking.value.map(function (v) { return placementOptions.find(function (p) { return p.value === v; }); }), name: "placements-deeplinking", required: true, creatable: true, disabled: inSubmit, error: placementsDeepLinking.error, hasError: placementsDeepLinking.hasError, options: placementOptions, changeHandler: setPlacementsDeepLinking }) }), _jsx(Field, { label: "Enable Pre-Approval", description: "Enabling this will send the user to a to an intermediate URL during the dynamic registration process. This will allow you to authenticate/approve the registration.", children: _jsxs("div", { className: "toggle", children: [_jsx(Input, { type: "radio", name: "intermediate-target", value: "true", required: true, changeHandler: setLoadIntermediateTarget, id: "loadIntermediateTargetTrue", checked: loadIntermediateTarget.value === "true" }), _jsx("label", { htmlFor: "loadIntermediateTargetTrue", children: "Enabled" }), _jsx(Input, { type: "radio", name: "intermediate-target", value: "false", required: true, changeHandler: setLoadIntermediateTarget, id: "loadIntermediateTargetFalse", checked: loadIntermediateTarget.value !== "true" }), _jsx("label", { htmlFor: "loadIntermediateTargetFalse", children: "Disabled" })] }) }), loadIntermediateTarget.value === "true" &&
                                                        _jsx(Field, { label: "Pre-Approval URL", description: "For Dynamic Registration, this is the URL (on your server) that is provisioned to be receive pre-approval requests. This will be the page that allows you to authenticate the user requesting the dynamic registration request (ex. https://example.com/lti-dyn-reg). It will receive a GET request with a query parameter that you can use to authenticate the connection by querying our API.", children: _jsx(Input, { type: "text", value: dynamicRegistrationURL.value, name: "dyn-reg-url", maxLen: 500, required: true, validRegex: "^https?:\\/\\/[a-zA-Z0-9\\.\\-\\_]+.+", customErrorMessage: "Must be a valid URL starting with http(s)://", changeHandler: setDynamicRegistrationURL, error: dynamicRegistrationURL.error, hasError: dynamicRegistrationURL.hasError }) })] }), services.dynamicRegistration &&
                                            _jsx(Field, { label: "Enable Auto-Activation", description: "Enabling this will activate all registration done through the dynamic registration API. If you want to approve every registration request manually, then leave this disabled.", children: _jsxs("div", { className: "toggle", children: [_jsx(Input, { type: "radio", name: "auto-activate", value: "true", required: true, changeHandler: setAutoActivate, id: "autoActivateTrue", checked: autoActivate.value === "true" }), _jsx("label", { htmlFor: "autoActivateTrue", children: "Enabled" }), _jsx(Input, { type: "radio", name: "auto-activate", value: "false", required: true, changeHandler: setAutoActivate, id: "autoActivateFalse", checked: autoActivate.value !== "true" }), _jsx("label", { htmlFor: "autoActivateFalse", children: "Disabled" })] }) }), services.oauth &&
                                            _jsx(Field, { label: "OAuth Redirect URL", description: "This is the URL that users will be redirected to after they authenticate with the OAuth provider.", children: _jsx(Input, { type: "text", value: oauthRedirectURL.value, name: "oauth-redirect-url", maxLen: 500, required: true, validRegex: "^https?:\\/\\/[a-zA-Z0-9\\.\\-\\_]+.+", customErrorMessage: "Must be a valid URL starting with http(s)://", changeHandler: setOauthRedirectURL, error: oauthRedirectURL.error, hasError: oauthRedirectURL.hasError }) }), services.assetProcessor && planType === "provider" &&
                                            _jsxs(_Fragment, { children: [_jsx("div", { className: "card-header rounded-top bg-light mb-3", children: "Asset Processor Settings" }), _jsx(Field, { label: "Platform Notice URL", description: "LMS platforms send Asset Processor notices to LTIaaS, which forwards an ltik for each notice to this URL. Use the ltik with the /idtoken endpoint to retrieve the verified notice.", children: _jsx(Input, { type: "text", value: noticeURL.value, name: "notice-url", maxLen: 500, required: true, validRegex: "^https?:\\/\\/[a-zA-Z0-9\\.\\-\\_]+.+", customErrorMessage: "Must be a valid URL starting with http(s)://", changeHandler: setNoticeURL, error: noticeURL.error, hasError: noticeURL.hasError }) })] }), ((_c = userData.currentAccount.features) === null || _c === void 0 ? void 0 : _c.error_notifications) &&
                                            _jsxs(_Fragment, { children: [_jsx("div", { className: "card-header rounded-top bg-light mb-3", children: "Notifications On API Errors" }), _jsxs(Field, { label: "Email Address", description: "LTIAAS can send you an email when your API generates an unexpected error. Enter an email address below and our API monitoring service will notify you with information that you can use to take action in the event of an error generated by our API.", extra: emailTestMessage, children: [_jsx(Input, { type: "text", value: apiErrorEmail.value, name: "error_notification-email", maxLen: 500, required: false, validRegex: "[a-z0-9]+@[a-z]+\.[a-z]{2,3}", customErrorMessage: "Must be a valid email address", changeHandler: setApiErrorEmail, error: apiErrorEmail.error, hasError: apiErrorEmail.hasError }), _jsxs("button", { className: "btn btn-primary mt-1", style: { float: "right" }, disabled: inTestEmail || apiErrorEmail.hasError || apiErrorEmail.value === "", onClick: sendTestEmail, children: [inTestEmail && _jsx(Loader, {}), " Send Test Email"] })] })] }), errorMessage !== null && (_jsx(Alert, { type: "danger", message: errorMessage, dismissible: true, onDismiss: function () { return setErrorMessage(null); } }))] }) })] })] }) }) }));
};
export default APISettings;
